import React, { useRef } from "react";
import RecentBallResults from "../components/RecentBallResults";
import LiveBattingTable from "../components/LiveBattingTable";
import TeamScores from "../components/TeamScores";
import "./EcricStream.scss";
import ReactPlayer from "react-player";

// const parentDomains = [
//   'www.indibet.com', 
//   'indibet.com', 
//   'indibetsportsbook.com', 
//   'www.indibetsportsbook.com',
//   'www.indibetstage.com', 
//   'indibetstage.com', 
//   'indibetsportsbookstage.com',
//   'www.indibetsportsbookstage.com',
//   'www.ib91.in',
//   'ib91.in',
//   'www.salad6688.com',
//   'salad6688.com',
//   'www.decimalcricket.net',
//   'decimalcricket.net',
//   'staging.decimalcricket.net',
//   'widget-staging.decimalcricket.net',
//   'www.intelligentcricket.com',
//   'intelligentcricket.com',
//   'staging.intelligentcricket.com',
//   'www.orbitestnd.com',
//   'orbitestnd.com',
//   'www.bfb247stage.com',
//   'bfb247stage.com',
//   'pb77stage.co',
//   'all.testjj9.com',
//   'www.orbitxch.com',
//   'orbitxch.com',
//   'www.indi.club',
//   'indi.club',
//   'www.indibet.in',
//   'indibet.in',
//   'www.indi.bet',
//   'indi.bet',
//   'www.indijeeto.com',
//   'indijeeto.com',
//   'www.indi100.com',
//   'indi100.com',
//   'www.bfb247.com',
//   'bfb247.com',
//   'www.pb77.co',
//   'pb77.co',
//   'www.96in.com',
//   '96in.com',
//   'www.tc20003.com',
//   'tc20003.com'
// ]

const Clip = ({ stream_url, domains }) => {
  const videoRef = useRef(null);

  return (
    <div className="clip">
      <ReactPlayer
        url={stream_url}
        controls={true}
        muted={true}
        playing={true}
        ref={videoRef}
        width="100%"
        height="100%"
        config={{
          twitch: {
            options: {
              parent: domains
            }
          },
        }}
      />
    </div>
  );
};

export default function EcricStream({
  layout,
  teams,
  event,
  scorecard,
  scoregrid,
  scoreboard,
  backgroundColor,
  gameType,
  fullscreenCartoon,
  domains
}) {
  //Get stream url from event scoreboard
  const stream_url = event.scoreboard.find(
    (element) => element.name === "stream_url"
  ).value;

  if (!scorecard && gameType !== "KABD") {
    return null;
  }

  const { overs } = scoregrid || {};

  const { inns1, inns2, inns3, inns4 } = overs || {};

  let recentOvers = [];

  if (inns1) {
    inns1.forEach((over) => {
      let balls = [];

      for (let i = 1; i <= 12; i++) {
        if (over["b" + i]) {
          balls.unshift(over["b" + i]);
        }
      }

      recentOvers.unshift({
        over: over.ov,
        balls,
      });
    });
  }

  if (inns2) {
    inns2.forEach((over) => {
      let balls = [];

      for (let i = 1; i <= 12; i++) {
        if (over["b" + i]) {
          balls.unshift(over["b" + i]);
        }
      }

      recentOvers.unshift({
        over: over.ov,
        balls,
      });
    });
  }

  if (inns3) {
    inns3.forEach((over) => {
      let balls = [];

      for (let i = 1; i <= 12; i++) {
        if (over["b" + i]) {
          balls.unshift(over["b" + i]);
        }
      }

      recentOvers.unshift({
        over: over.ov,
        balls,
      });
    });
  }

  if (inns4) {
    inns4.forEach((over) => {
      let balls = [];

      for (let i = 1; i <= 12; i++) {
        if (over["b" + i]) {
          balls.unshift(over["b" + i]);
        }
      }

      recentOvers.unshift({
        over: over.ov,
        balls,
      });
    });
  }

  return (
    <div
      className="cartoons"
      style={{
        backgroundColor,
        display: layout === "double" ? "flex" : "block",
      }}
    >
      {layout === "single" && ! fullscreenCartoon && (
        <>
          <TeamScores teams={teams} event={event} scoreboard={scoreboard} />
          <LiveBattingTable scoreboard={scoreboard} />
        </>
      )}

      <div
        className="video-wrapper"
        style={{
          display: layout === "double" ? "flex" : "block",
        }}
      >
        <Clip stream_url={stream_url} domains={domains}/>
        {layout === "single" && ! fullscreenCartoon && <RecentBallResults scoregrid={scoregrid} />}
      </div>
    </div>
  );
}
